import React, { useEffect, useRef } from 'react'
import './PhoneInput.scss'
import PhoneInputReact from 'react-phone-number-input/input'
import 'react-phone-number-input/style.css'
import { E164Number } from 'libphonenumber-js/types.cjs'
import { BlurEvent, FieldError } from 'common.types'
import { RequiredBar, InputStatusIcon, FieldErrorList } from 'components'
import { getInputClasses } from 'utilities/utilities'

interface CheckboxInputProps {
  label: string
  value: string
  required: boolean
  onChange: (value?: E164Number | undefined) => void
  onBlur?: (e: BlurEvent) => void
  placeholder?: string
  name: string
  errorList?: FieldError[]
}

export const PhoneInput: React.FC<CheckboxInputProps> = ({
  label,
  required,
  value,
  onChange,
  onBlur,
  name,
  errorList,
}) => {
  const errorsExist = errorList && errorList.length > 0
  const phoneInputRef = useRef()
  const inputEntered = value ? true : false
  useEffect(() => {
    const currentPhoneInput = phoneInputRef.current
    const blurFxn = (e: any) => {
      if (onBlur) {
        onBlur(e)
      }
    }
    if (currentPhoneInput && onBlur) {
      ;(currentPhoneInput as any).addEventListener('blur', blurFxn)
    }
    return () => {
      if (currentPhoneInput && onBlur) {
        ;(currentPhoneInput as any).removeEventListener('blur', blurFxn)
      }
    }
  }, [onBlur])
  return (
    <div className="phone-input">
      <label className="phone-input__label" htmlFor={name}>
        {required && (
          <span className="phone-input__label__required-asterisk">*</span>
        )}
        {label}
      </label>
      <fieldset className="phone-input__fieldset" name={name}>
        <div
          className={`phone-input__input ${getInputClasses(
            errorsExist,
            inputEntered,
          )}`}
        >
          <div className="phone-input__input__inner">
            <RequiredBar
              isRequired={required}
              errorsExist={errorsExist}
              inputEntered={inputEntered}
            />
            <PhoneInputReact
              ref={phoneInputRef}
              smartCaret
              country="US"
              value={value}
              onChange={onChange}
            />
          </div>
          <InputStatusIcon
            errorsExist={errorsExist}
            inputEntered={inputEntered}
          />
        </div>
        <FieldErrorList errorListForField={errorList} />
      </fieldset>
    </div>
  )
}
